import React from 'react';
import { TagsWrapper } from '@domain/integrations/integrations-list/integration-tags/integration-tags.styles';
import { Tooltip } from '@paretogroup/tess';

import { Tag } from '@shared/pareto-workflows/tags/tags.types';
import {
    IntegrationTagsIcons,
} from './integration-tags.constants';

interface IntegrationTagsProps{
    tags: Tag[]
}

export const IntegrationTags = ({ tags }:IntegrationTagsProps): React.ReactElement => (
    <TagsWrapper tags={tags}>
        {!!tags && tags.map(({ label }) => {
            const Icon = IntegrationTagsIcons[label];

            if (!Icon) {
                return null;
            }

            return (
                <Tooltip title={label} placement="top">
                    <span>
                        <Icon size={10} primaryColor="#272727" secondaryColor="#272727" tertiaryColor="#888888" />
                    </span>
                </Tooltip>
            );
        })}
    </TagsWrapper>
);
